import React, { Component } from 'react'

export default class NotFound extends Component {
  render() {
    return (
      <div>
        <h3>The page is not found</h3>
      </div>
    )
  }
}
